import { render, staticRenderFns } from "./PaymentTypePeriodList.vue?vue&type=template&id=62e248ae"
import script from "./PaymentTypePeriodList.vue?vue&type=script&lang=js"
export * from "./PaymentTypePeriodList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports